import { isEmpty, isNil } from "lodash";
import Flx from "../../../layout/Flx";
import { ASSOCIATION_CONFIG } from "../../config/associationConfig";
import AssociationSelectorDropdown from "./AssociationSelectorDropdown";
const AssociationSelector = ({
  loan,
  associationIds,
  activeAssociationKeys,
  onAdd,
}) => {
  // Early return if required data is missing
  if (isNil(loan)) {
    return null;
  }

  if (!Array.isArray(activeAssociationKeys)) {
    console.warn("AssociationSelector: activeAssociationKeys is not an array");
    return null;
  }

  return (
    <Flx gap={1}>
      {activeAssociationKeys.map((key) => {
        const config = ASSOCIATION_CONFIG[key];
        if (!config) {
          console.warn(`AssociationSelector: No config found for key "${key}"`);
          return null;
        }

        let options = [];
        try {
          if (config.getLoanData) {
            options = config.getLoanData(loan);
          }
        } catch (error) {
          console.error(`Error getting loan data for ${key}:`, error);
          return null;
        }

        if (isEmpty(options)) {
          return null;
        }

        return (
          <AssociationSelectorDropdown
            key={key}
            config={config}
            options={options.map((item) => ({
              _id: item?._id,
              label: config.getLabel ? config.getLabel(item) : "Unknown",
              icon: config.icon,
            }))}
            onClick={(id) => onAdd(id, key)}
            associationIds={associationIds}
            associationKey={key}
          />
        );
      })}
    </Flx>
  );
};

export default AssociationSelector;
